/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import {
  Box,
  GDSStyleObject,
  ParagraphText,
  Tabs,
  StackLayout,
  useMediaQuery,
  queryHelpers,
} from '@leagueplatform/genesis-core';
/* eslint-disable no-else-return */
import { useConfigProperty } from '@leagueplatform/core';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import {
  useParamsLegacy as useParams,
  useNavigateLegacy as useNavigate,
} from '@leagueplatform/routing';
import { EVENT_NAME, trackAnalyticsEvent } from '@leagueplatform/analytics';
import { FORMS_LIBRARY_ASSET_KEYS } from '../../types/forms-library.types';
import {
  HIGHMARK_APP_TYPE,
  FORM_PLAN_TYPE,
} from '../../types/online-forms.types';
import { FormsReusableComponent } from '../reusable-components/form-structure.component';
import { getAccessToken } from '../forms/helpers';

import { ErrorModal } from '../forms/layout/errorModal';
import { formsLibrary } from '../../forms-library.config';
import { NoFormAvailable } from '../forms/layout/noFormAvailable';

export const ENV_STORAGE_KEY = 'hm-env';

export function TabsComponent(props: any) {
  const {
    openForm,
    closeForm,
    ubk,
    onGroupNumberChange,
    onFormsChange,
    accessToken,
    isUbkLoading,
    isPdfLoading,
  } = props;
  const tenantId = useConfigProperty('core.tenantId');
  const [tabsData, setTabsData] = useState<string[]>();
  const [formsData, setFormsData] = useState<any>({});
  const [isPlansLoading, setPlansLoading] = useState<boolean>(false);
  const [isFormsLoading, setFormsLoading] = useState<boolean>(false);
  const [errMsg, setErrMsg] = useState(null);
  const [groupNumber, setGroupNumber] = useState(null);
  const [isPlanData, setIsPlanData] = useState<boolean>(false);
  const [isCOBEligible, setCOBEligible] = useState<boolean>(false);
  const [defaultPlan, setDefaultPlan] = useState(null);
  const isBelow400 = useMediaQuery(queryHelpers.down(400));
  const { selectedTab }: any = useParams();
  const navigate = useNavigate();
  const visualIcon = useStaticAsset(FORMS_LIBRARY_ASSET_KEYS.VISUAL_ICON);
  const config = formsLibrary.getConfig();
  const { HIGHMARK_API_URL, useCurrentRegionUbkHeader } = config;
  const currentUbk: any = useCurrentRegionUbkHeader() || null;
  const ubkValue = currentUbk?.headers?.Brandubk || null;

  useEffect(() => {
    if (!selectedTab) {
      navigate('/forms-library/medical', { replace: true });
    }
  }, [selectedTab]);

  const getPlans = (planData: any) => {
    const plans: any[] = [];
    const planDetailsData: any[] = [];
    planData.forEach((plan: any) => {
      const casingPlanType =
        plan.planType.charAt(0).toUpperCase() + plan.planType.slice(1);
      if (plans.indexOf(casingPlanType) === -1) {
        plans.push(casingPlanType);
        if (casingPlanType === 'Dental' || casingPlanType === 'Vision') {
          planDetailsData.push(plan);
        }
      }
      if (plan.integrated) {
        const integratedPlans = plan.integrated.map((intPlan: any) => ({
          planYear: plan.planYear,
          groupNumber: plan.groupNumber,
          productNumber: plan.productNumber,
          planType: intPlan.planType,
        }));
        getPlans(integratedPlans).map((planType) => {
          if (plans.indexOf(planType) === -1) {
            plans.push(planType);
          }
          return 0;
        });
      }
    });

    if (planDetailsData.length !== 0) {
      const planDetailsKeys = JSON.parse(
        sessionStorage.getItem('planDetailsKeys') || '[]',
      );
      const planTypeKeys = planDetailsKeys.map(
        (planDetails: any) => planDetails.planType,
      );
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < planDetailsData.length; i++) {
        if (planTypeKeys.indexOf(planDetailsData[i].planType) === -1) {
          planDetailsKeys.push(planDetailsData[i]);
        }
      }
      sessionStorage.setItem(
        'planDetailsKeys',
        JSON.stringify(planDetailsKeys),
      );
    }
    return plans;
  };

  const getFormsData = () => {
    const newTab = selectedTab === 'drug' ? 'pharmacy' : selectedTab;
    const formsDataUrl = `${HIGHMARK_API_URL}/digital/v1/members/forms-library/forms?formType=${newTab}`;
    setFormsLoading(true);
    getAccessToken(formsDataUrl, ubkValue, 'forms', accessToken).then(
      (result: any) => {
        setFormsLoading(false);
        const formsApiData = result?.forms;
        const formType = result?.type;
        const errData = result?.errMsg;
        if (formType === newTab) {
          if (formsApiData) {
            result.forms.sort((formA: any, formB: any) => {
              const textA = formA.headingText.toLowerCase();
              const textB = formB.headingText.toLowerCase();
              if (textA < textB) return -1;
              if (textA > textB) return 1;
              return 0;
            });
            setFormsData(result);
            onFormsChange(result);
          } else if (errData) {
            setErrMsg(errData);
          }
        }
      },
    );
  };

  const setTabsContent = (plansArray: any[]) => {
    const appName = tenantId || sessionStorage.getItem(ENV_STORAGE_KEY);
    if (appName === HIGHMARK_APP_TYPE.AMH) {
      const withoutDental = plansArray?.filter(
        (val: any) => val !== FORM_PLAN_TYPE.DENTAL,
      );
      setTabsData(withoutDental);
    } else {
      setTabsData(plansArray);
    }
  };

  const getMedicarePlanData = (plansArr: any) => {
    const formsDataUrl = `${HIGHMARK_API_URL}/digital/v1/members/health/services`;
    setPlansLoading(true);
    getAccessToken(formsDataUrl, ubkValue, '', accessToken).then(
      (result: any) => {
        setPlansLoading(false);
        const medicarePlanServicesData = result?.services;
        const errData = result?.errMsg;
        if (medicarePlanServicesData) {
          const medicarePlanData = medicarePlanServicesData?.filter(
            (medPlan: any) =>
              medPlan.name === FORM_PLAN_TYPE.MEDICARE ||
              medPlan.name === FORM_PLAN_TYPE.MEDIGAP ||
              medPlan.name === FORM_PLAN_TYPE.MEDICARE_ADVANTAGE,
          )[0];
          if (medicarePlanData) {
            plansArr.push(FORM_PLAN_TYPE.MEDICARE);
          }

          const plansArrLower = plansArr.map((plan: any) => plan.toLowerCase());
          console.log('Plans Array -> ', plansArrLower);
          const defaultTab = plansArrLower[0] ? plansArrLower[0] : null;
          if (selectedTab) {
            if (
              selectedTab === 'medical' &&
              plansArrLower.indexOf(selectedTab) === -1 &&
              defaultTab
            ) {
              console.log(`Default Tab ${defaultTab} exists for the user`);
              setDefaultPlan(defaultTab);
              setTabsContent(plansArr);
            } else if (plansArrLower.indexOf(selectedTab) === -1) {
              console.log(
                `selected Tab ${selectedTab} doesn't exist for the user`,
              );
              setIsPlanData(true);
            } else {
              console.log(`selected Tab ${selectedTab} exists for the user`);
              setTabsContent(plansArr);
              console.log(`Tab is ${selectedTab}`);
              if (selectedTab) {
                getFormsData();
              }
            }
          }
        } else if (errData) {
          setErrMsg(errData);
        }
      },
    );
  };

  const getCobEligibleData = (medicalGrpNum: string) => {
    const cobEligibilityUrl = `${HIGHMARK_API_URL}/digital/v2/members/coordination-of-benefits/eligibility`;
    getAccessToken(cobEligibilityUrl, ubkValue, '', accessToken).then(
      (result: any) => {
        const cobEligibleGrps = result?.eligibleGroups;
        if (
          cobEligibleGrps.length > 0 &&
          medicalGrpNum &&
          cobEligibleGrps?.includes(medicalGrpNum)
        ) {
          setCOBEligible(true);
        }
      },
    );
  };

  const getPlanData = () => {
    const plansUrl = `${HIGHMARK_API_URL}/digital/v1/members/benefits/plans?planYear=all`;
    setPlansLoading(true);
    getAccessToken(plansUrl, ubkValue, '', accessToken).then((result: any) => {
      setPlansLoading(false);
      const plansData = result?.plans;
      setIsPlanData(plansData === undefined || plansData === null);
      const errData = result?.errMsg;
      const sortingOrder = Object.values(FORM_PLAN_TYPE);

      if (plansData) {
        const gpNumber = plansData?.find((val: any) => val.groupNumber);
        const medicalPlan = plansData?.find(
          (val: any) => val.planType === 'medical',
        );
        if (medicalPlan && medicalPlan.groupNumber) {
          getCobEligibleData(medicalPlan.groupNumber);
        }
        setGroupNumber(gpNumber);
        onGroupNumberChange(gpNumber.groupNumber);
        const planDataType = getPlans(plansData);
        const filteredPlanDataType = planDataType?.filter(
          (val: any) =>
            Object.values(FORM_PLAN_TYPE).toString().split(',').indexOf(val) >
            -1,
        );
        const sortedPlanDataType = filteredPlanDataType?.sort(
          (tab1, tab2) =>
            sortingOrder.indexOf(tab1) - sortingOrder.indexOf(tab2),
        );
        getMedicarePlanData(sortedPlanDataType);
      } else if (errData) {
        setErrMsg(errData);
      }
    });
  };

  const clearErrMsg = () => {
    setErrMsg(null);
    getPlanData();
    closeForm();
  };

  useEffect(() => {
    if (accessToken) {
      getPlanData();
    }
  }, [accessToken]);

  useEffect(() => {
    if (selectedTab && accessToken) {
      getFormsData();
    }
  }, [selectedTab]);

  useEffect(() => {
    if (defaultPlan) {
      navigate(`/forms-library/${defaultPlan}`);
    }
  }, [defaultPlan]);

  useEffect(
    () => () => {
      setDefaultPlan(null);
    },
    [],
  );

  const trackAnalytics = (name: string) => {
    trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
      detail: name,
      product_area: name,
      screen_name: 'Forms Library',
      path: window.location.pathname,
      event_author: 'engen',
    });
  };

  const tabChange = (tab: string) => {
    navigate(`/forms-library/${tab}`);
    trackAnalytics(tab);
  };

  return (
    <StackLayout
      css={
        {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '$two $none',
          '@mobile': { width: isBelow400 ? '100%' : 'auto' },
        } as GDSStyleObject
      }
    >
      {errMsg && <ErrorModal onClose={clearErrMsg} />}
      {tabsData && (
        <Box
          css={
            {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '$two $none',
              '@mobile': { width: isBelow400 ? '100%' : 'auto' },
            } as GDSStyleObject
          }
        >
          <img src={visualIcon as string} alt="Visual Icon" height="150px" />
          <ParagraphText
            css={
              {
                margin: '24px 0px 24px 5px',
              } as GDSStyleObject
            }
          >
            Access your health plan forms all in one place. Download PDFs to
            mail or fax, or access online forms for easy submission.
          </ParagraphText>
          <Tabs.Root
            activationMode="manual"
            css={{
              margin: '0 0 12px 0',
              maxWidth: '900px',
            }}
            value={selectedTab}
            defaultValue={selectedTab}
          >
            <Tabs.TabList
              aria-label="tabs example"
              tabDistribution="distributeEvenly"
              css={{
                margin: 'auto 13px',
              }}
            >
              {tabsData.map((tab) => (
                <Tabs.Tab
                  css={{
                    cursor: 'pointer',
                    width: 'auto',
                  }}
                  key={tab}
                  value={
                    tab === FORM_PLAN_TYPE.DRUG
                      ? 'drug'
                      : tab.toLocaleLowerCase()
                  }
                  onClick={() =>
                    tab === FORM_PLAN_TYPE.DRUG
                      ? tabChange('drug')
                      : tabChange(tab.toLocaleLowerCase())
                  }
                >
                  {tab === FORM_PLAN_TYPE.DRUG ? FORM_PLAN_TYPE.PHARMACY : tab}
                </Tabs.Tab>
              ))}
            </Tabs.TabList>
            {isFormsLoading || isUbkLoading ? (
              <LoadingIndicator />
            ) : (
              <Box>
                {formsData && formsData.forms && (
                  <Tabs.TabPanel tabIndex={-1} value={selectedTab}>
                    {formsData.forms.map((form: any) => {
                      if (
                        form.headingText !==
                          'Other Insurance Information/COB' ||
                        (form.headingText ===
                          'Other Insurance Information/COB' &&
                          isCOBEligible)
                      ) {
                        return (
                          <FormsReusableComponent
                            formData={form}
                            groupNumber={groupNumber}
                            openForm={openForm}
                            ubk={ubk}
                            isPdfLoading={isPdfLoading}
                          />
                        );
                      }
                      return null;
                    })}
                  </Tabs.TabPanel>
                )}
              </Box>
            )}
          </Tabs.Root>
        </Box>
      )}
      {isPlansLoading && <LoadingIndicator />}
      {isPlanData && <NoFormAvailable />}
    </StackLayout>
  );
}
